var React = require('react');

function UiStats (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 3.5h3.158v17H2v-17zm8.421 3.188h3.158V20.5H10.42V6.687zM17.79 12h-3.158v8.5h3.158V12zM22 15.188h-3.158V20.5H22v-5.313zM9.368 8.811H6.211V20.5h3.157V8.812z","fill":"#fff"}));
}

UiStats.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = UiStats;

UiStats.default = UiStats;
